import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import type { IPatternType } from "@api/patterns";
import { useUIStore } from "@/stores/uiStore";

export const patternsRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.list.route,
      lazy: () => import("@pages/panelPages/patterns/patternsList"),
      loader: ({ request, params }) => {
        const type = params.type as IPatternType;

        useUIStore
          .getState()
          .setPage(
            request,
            `pageTitle.pattern_${type}_title`,
            [],
            "index",
            "main",
          );
        return { type };
      },
    },
    permissions: ["doctor"],
  },
  {
    route: {
      path: path.create.route,
      lazy: () => import("@pages/panelPages/patterns/patternsForm"),
      loader: ({ request, params }) => {
        const type = params.type as IPatternType;

        useUIStore.getState().setPage(
          request,
          `pageTitle.pattern_create`,
          [
            {
              title: `pageTitle.pattern_${type}_title`,
              url: path.list.link(type),
            },
          ],
          "create",
        );
        return { type };
      },
    },
    permissions: ["doctor"],
  },
  {
    route: {
      path: path.view.route,
      lazy: () => import("@pages/panelPages/patterns/patternsForm"),
      loader: ({ request, params }) => {
        const type = params.type as IPatternType;

        useUIStore.getState().setPage(
          request,
          `pageTitle.pattern_view`,
          [
            {
              title: `pageTitle.pattern_${type}_title`,
              url: path.list.link(type),
            },
          ],
          "view",
        );
        return { type, id: params.id };
      },
    },
    permissions: ["doctor"],
  },
  {
    route: {
      path: path.update.route,
      lazy: () => import("@pages/panelPages/patterns/patternsForm"),
      loader: ({ request, params }) => {
        const type = params.type as IPatternType;

        useUIStore.getState().setPage(
          request,
          `pageTitle.pattern_edit`,
          [
            {
              title: `pageTitle.pattern_${type}_title`,
              url: path.list.link(type),
            },
          ],
          "edit",
        );
        return { type, id: params.id };
      },
    },
    permissions: ["doctor"],
  },
];
